import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RentalsService } from '../../../../../../services/rentals.service';
import { HelpersService } from '../../../../../../services/helpers.service';
import { AppConfig } from '../../../../../../app.config';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-reservation-print-out',
  templateUrl: './reservation-print-out.component.html',
  styleUrls: ['./reservation-print-out.component.scss'],
})
export class ReservationPrintOutComponent implements OnInit {
  public reservationIdentifier: string = null;
  public reservation: any = {};
  public displayDateTimeFormat: string = 'dd-MM-yyyy HH:mm';
  public qrCodeURL : string = "";

  constructor(
    private route: ActivatedRoute,
    private rentalsService: RentalsService,
    private translate: TranslateService,
    public helpersService: HelpersService,
    private appConfig: AppConfig,
  ) {}

  ngOnInit() {
    var profile = this.helpersService.getProfileData();
    this.route.params.subscribe((res: any) => {
      this.reservationIdentifier = res.reservationIdentifier;
      this.translate.setDefaultLang(
        (this.appConfig.getPartnerType() === 'bicycle'
          ? ''
          : this.appConfig.getPartnerType() + '/') +
          (profile.Locale ? profile.Locale : 'en'),
      );
      this.getReservationPrintSummary();
    });
  }

  getReservationPrintSummary() {
    this.rentalsService
      .getReservationPrintSummary(this.reservationIdentifier)
      .subscribe((summary) => {
        this.reservation = summary;
        this.displayDateTimeFormat = summary.AngularDateFormat + ' h:mm a';
        
        this.qrCodeURL= this.appConfig.getEnvironmentNew().portalUrl + "store/rentals/reservations-summary?reservationID=" + this.reservation.id;

        setTimeout(() => {
          window.print();
        }, 1000);
      });
  }
}
